import React from 'react';
import { Plus, Trash2, ChevronUp, ChevronDown, ListChecks } from 'lucide-react';
import { Button, Input, Textarea } from '../../ui-v2';

// Mismo tope que el servidor (campanasValidator.MAX_DESCRIPCION_SUBTAREA).
const MAX_DESCRIPCION = 2000;

export default function Paso2Subtareas({ payload, errores = [], dispatch }) {
  const subs = payload.subtareas || [];
  // Los 422 del servidor sobre las subtareas (campo 'subtareas'): aquí, junto a la lista.
  const erroresSubtareas = errores.filter((e) => e.campo === 'subtareas');

  return (
    <div className="space-y-4 max-w-2xl">
      <p className="text-sm text-slate-500">
        Lista de tareas que el técnico irá marcando durante cada intervención.
        Es opcional: si no añades ninguna, la cita se marca como realizada al completarse.
      </p>

      {erroresSubtareas.length > 0 && (
        <ul className="border border-red-200 bg-red-50 rounded-lg p-3 text-sm text-red-700 space-y-1">
          {erroresSubtareas.map((e, i) => <li key={i}>{e.mensaje}</li>)}
        </ul>
      )}

      {subs.length === 0 && (
        <div className="border border-dashed border-slate-200 rounded-lg p-8 text-center text-slate-400">
          <ListChecks className="w-6 h-6 mx-auto mb-2 opacity-50" />
          Sin subtareas. Las intervenciones se considerarán completas sin checklist.
        </div>
      )}

      <ul className="space-y-2">
        {subs.map((s, i) => (
          <li
            key={i}
            className="border border-slate-200 rounded-lg bg-white p-3 flex items-start gap-3"
          >
            <div className="flex flex-col">
              <button
                type="button"
                disabled={i === 0}
                onClick={() => dispatch({ type: 'SUBTAREA_MOVE', from: i, to: i - 1 })}
                className="w-6 h-6 grid place-items-center rounded hover:bg-slate-100 disabled:opacity-30 disabled:cursor-not-allowed"
                aria-label="Subir"
              >
                <ChevronUp className="w-3.5 h-3.5 text-slate-500" />
              </button>
              <span className="text-[10px] text-slate-400 text-center font-mono">
                {i + 1}
              </span>
              <button
                type="button"
                disabled={i === subs.length - 1}
                onClick={() => dispatch({ type: 'SUBTAREA_MOVE', from: i, to: i + 1 })}
                className="w-6 h-6 grid place-items-center rounded hover:bg-slate-100 disabled:opacity-30 disabled:cursor-not-allowed"
                aria-label="Bajar"
              >
                <ChevronDown className="w-3.5 h-3.5 text-slate-500" />
              </button>
            </div>

            <div className="flex-1 space-y-2">
              <Input
                value={s.nombre}
                onChange={(e) =>
                  dispatch({ type: 'SUBTAREA_UPDATE', index: i, field: 'nombre', value: e.target.value })
                }
                placeholder="Nombre de la subtarea"
                className="text-sm"
              />
              <Textarea
                value={s.descripcion || ''}
                onChange={(e) =>
                  dispatch({ type: 'SUBTAREA_UPDATE', index: i, field: 'descripcion', value: e.target.value })
                }
                placeholder="Descripción opcional"
                rows={2}
                maxLength={MAX_DESCRIPCION}
                className="text-xs"
              />
            </div>

            <button
              type="button"
              onClick={() => dispatch({ type: 'SUBTAREA_REMOVE', index: i })}
              className="w-8 h-8 grid place-items-center rounded-lg hover:bg-red-50 shrink-0"
              aria-label="Eliminar subtarea"
              title="Eliminar subtarea"
            >
              <Trash2 className="w-4 h-4 text-red-500" />
            </button>
          </li>
        ))}
      </ul>

      <Button
        variant="outline"
        onClick={() => dispatch({ type: 'SUBTAREA_ADD' })}
        className="text-sm"
      >
        <Plus className="w-4 h-4" />
        Añadir subtarea
      </Button>
    </div>
  );
}
